(function() {
    var ui = fpUtil.getNamespace('ui', fp);

    ui.DropdownPhoneCountry = fp.Component.extend({
        construct: function(element, config, template, parent) {
            template = ui.getTemplate('component/0/phone-country-dropdown.html');
            this._super(element, config, template, parent);
            this.init(config.autoRender);
        },
        render: function(params) {
            this._super(params);

            var self = this,
                scope = this.scope,
                $element = this.$element;

            $element.find('.fp-dropdown-country-code').each(function() {
                var $countryCodeDropdown = $(this),
                    $phoneInput = $countryCodeDropdown.closest('.fp-phone-country').find('input[type="tel"]');

                $countryCodeDropdown.dropdown({
                    autoInit: true,
                    ariaLabel: fp.ui.locale('aria-label-dropdown-country-code', 'Select phone country code')
                });

                const defaultCountryCode = scope.userAddressConfig && scope.userAddressConfig.default_country_code,
                    isPhoneAlt = $phoneInput.attr('name') === 'fp-input-phone_alt';
                let countryPhoneCode;

                if(_.size(scope.address)) countryPhoneCode = !isPhoneAlt ? scope.address.phone_country : scope.address.phone_alt_country;
                else countryPhoneCode = scope.countryPhoneCode;

                if(!countryPhoneCode) {
                    countryPhoneCode = defaultCountryCode || fp.config.countryCode || '';
                    countryPhoneCode = countryPhoneCode.toLowerCase();
                }
                
                $countryCodeDropdown.data('fp.ui.Component').setValue(countryPhoneCode);
                $countryCodeDropdown.find('.fp-country-code-flag').val(countryPhoneCode);
            });
        }
    });
})();